export interface ClientTargetRow {
  clientName: string;
  target: number;
  actual: number;
  variance: number;
  achievement: number; // %
};

export interface ClientTargetHeader {
  aopTarget: number;
  monthlyActual: number;
};